// src/api/trainingApi.js
import httpClient from '../utils/httpClient';

export async function startTraining(planId) {
  // hits PATCH /api/training_plans/:id/start
  await httpClient.patch(`/api/training_plans/${planId}/start`);
}
export async function completeTraining(planId, conversation, meetingData, timeSpentInSeconds) {
  const { data } = await httpClient.patch(
    `/api/training_plans/${planId}/complete`,
    { conversation, meetingData, timeSpentInSeconds }
  );
  return data;
}

export const getTrainingPlanById = async (trainingPlanId) => {
  try {
    const response = await httpClient.get(`/api/training_plans/${trainingPlanId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching training plan:', error.message);
    throw error;
  }
};

export async function getTrainingConversation(trainingPlanId) {
  const res = await httpClient.get(`/api/training_plans/${trainingPlanId}/conversation`);
  return res?.data?.conversation ?? [];
}
export async function scheduleTrainingPlan(planId, scheduledTime) {
  const r = await httpClient
    .patch(`/api/training_plans/${planId}/schedule`, { scheduledTime });
  return r.data;
}